import { render, staticRenderFns } from "./CompanyTargets.vue?vue&type=template&id=5d713a19&scoped=true&"
import script from "./CompanyTargets.vue?vue&type=script&lang=js&"
export * from "./CompanyTargets.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTargets.vue?vue&type=style&index=0&id=5d713a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d713a19",
  null
  
)

export default component.exports